/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutAlignBottom = createReactComponent("outline", "layout-align-bottom", "IconLayoutAlignBottom", [["path", { "d": "M4 20l16 0", "key": "svg-0" }], ["path", { "d": "M9 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

export { IconLayoutAlignBottom as default };
//# sourceMappingURL=IconLayoutAlignBottom.mjs.map
